import { Divider } from "antd";
import ContentPadding from "../ContentConfig/ContentPadding";
import { ColorPickerFormItem } from "../Image/ImageConf";
import ContentID from "../Common/ContentID";

export default ({ node }) => {
  return (
    <>
      <ColorPickerFormItem
        label={"Background Color"}
        name="backgroundColor"
        color={node.data.backgroundColor}
      />
      <Divider />
      <ContentID />
      <ContentPadding />
    </>
  );
};
